import PassportItem from '@/components/Record/SubjectContent/PassportItem';
import ShareDetailButton from '@/components/Record/ShareButton/ShareDetailButton';
import React, { useState } from 'react';
import { RecordFilter, ShareMode, TalkFlowShare } from '@/types/api';

import styled from '@emotion/styled';
import {
  useChangeTalkFlowShareMode,
  useDeleteTalkFlowShareMode,
} from '@/hooks/apiHooks';
import { useFormContext } from 'react-hook-form';
import { roleToFilter } from '@/components/Record/util/function';
import usePlatform from '@/components/Record/hooks/usePlatform';

type P = {
  shareData: TalkFlowShare[];
  mutate(): void;
  disabled?: boolean;
};

const ShareList = ({ shareData, mutate, disabled }: P) => {
  const { getValues } = useFormContext<RecordFilter>();
  const [loading, setLoading] = useState(false);
  const { isMobilePath } = usePlatform();

  const handleChangeMode = async (mode: ShareMode, aclId: string) => {
    const docId = getValues('docId');
    setLoading(true);
    try {
      switch (mode) {
        case ShareMode.Delete:
          await useDeleteTalkFlowShareMode(docId, aclId);
          break;
        case ShareMode.Comment:
          await useChangeTalkFlowShareMode(docId, {
            role: 'reader',
            roleId: aclId,
          });
          break;
        case ShareMode.Share:
          await useChangeTalkFlowShareMode(docId, {
            role: 'sharer',
            roleId: aclId,
          });
          break;
      }
    } catch (e) {
      console.log(e);
    } finally {
      await mutate();
      setLoading(false);
    }
  };

  return (
    <Container disabled={disabled} mobileMode={isMobilePath}>
      {shareData.map((res) => (
        <PassportItem
          key={`share-${res.detailInfo.passportId}`}
          passport={res.detailInfo}
          disabled={disabled}
          rightContents={
            <ShareDetailButton
              shareMode={roleToFilter(res.role)}
              onClick={(mode) => handleChangeMode(mode, res.id)}
              disabled={disabled || loading}
            />
          }
        />
      ))}
    </Container>
  );
};
export default ShareList;

const Container = styled.div<{ disabled?: boolean; mobileMode?: boolean }>`
  margin-top: ${({ disabled }) => (disabled ? '0' : '16px')};
  padding-top: ${({ disabled }) => (disabled ? '0' : '16px')};
  border-top: ${({ disabled, mobileMode }) =>
    disabled ? '' : mobileMode ? '8px solid #F9FAFB' : '1px solid #e7e9ec'};
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 500px;
  overflow-y: scroll;
  padding-left: ${({ mobileMode }) => (mobileMode ? '20px' : '')};
  padding-right: ${({ mobileMode }) => (mobileMode ? '20px' : '')};
`;
